import React from "react";

import { BetBuilderActionsTypeEnum } from "@data-types/analytics-tracker/BetBuilderInteractionTypeEnum";
import { BettingTypeHeaderBettingGroupsButtonInfo } from "@features/offer/desktop/grouped-event-offer/components";
import { EventContentTab } from "@features/offer/shared/event";
import { OfferStore } from "@state/context/offer/OfferContext";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import { analyticsTracker } from "@utils/analytics";
import { observer } from "mobx-react";

export const BettingTypeHeaderBettingGroupsButton = observer(
	function BettingTypeHeaderBettingGroupsButton(props: {
		bettingTypeGroup: BettingTypeHeaderBettingGroupsButtonInfo;
		tabIndex: number;
	}) {
		const { bettingTypeGroup } = props;
		const isBetBuilder = bettingTypeGroup.abrv === "bet-builder";

		const store = useOfferContext<OfferStore.EventViewStore>();

		return (
			<EventContentTab
				textContent={bettingTypeGroup.name}
				isActive={store.displayBettingGroup === bettingTypeGroup.abrv}
				onClick={() => {
					store.setDisplayBettingGroup(bettingTypeGroup.abrv);
					if (isBetBuilder) {
						store.setBBParms("true");
						analyticsTracker.trackBetBuilderInteraction(
							BetBuilderActionsTypeEnum.BBTabOpen
						);
					} else {
						store.setBBParms("");
					}
				}}
				hasBBIcon={isBetBuilder}
			/>
		);
	}
);
